// extracted by mini-css-extract-plugin
export default {"field":"Markdown_field__HfS3Z"};